var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "widM" }, [
      _c("p", { staticClass: "fntH5 fntL txtC marTX" }, [
        _c("strong", [_vm._v("개인정보 수집 이용에 대한 동의")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "fntH6 marTL padLS padRS" }, [
        _c("b", [
          _vm._v(
            "한국암웨이㈜는 A7070 스킨 뉴트리션 이벤트를 위하여 다음과 같이 귀하의 개인정보를 수집, 이용합니다."
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "osResWarning marTSM padLS padRS" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              "○  수집하는 개인정보의 항목 : 이름/연락처/ABO 번호(또는 소비자 번호)"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("○  개인정보의 수집 및 이용 목적 :"),
            _c("br"),
            _vm._v(
              "\n          - A7070 스킨뉴트리션 이벤트 선정자의 증정품 배송\n      "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("○  개인정보의 보유 및 이용기간 : "),
            _c("b", { staticClass: "fntP bolder" }, [
              _vm._v("개인정보 수집일로부터 3개월")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "fntH6 marTSM" }, [
        _c("b", [
          _vm._v(
            "※ 귀하는 위 동의를 거부할 권리가 있으나, 이에 동의하지 않는 경우 A7070 스킨 뉴트리션 이벤트 참여가 불가합니다."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ca24d47", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ca24d47","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/relayevent/component/header_privacy.vue
// module id = null
// module chunks = 